import { createApiClient } from './client'
export { API_URL } from './client'
export default createApiClient()
